import { useEffect, useState } from "react"
import { vehiclesApi } from "../api/endpoints"
import { useVehicleStore } from "../store/vehicleStore"
import type { VehicleCard } from "../types/api"

export function useGarageDisplayVehicle(preferOwnedGarage = false, enabled = true) {
  const { currentVehicle, loadSuggestedVehicle } = useVehicleStore()
  const [vehicle, setVehicle] = useState<VehicleCard | null>(enabled && !preferOwnedGarage ? currentVehicle : null)
  const [isLoading, setIsLoading] = useState(enabled)

  useEffect(() => {
    let cancelled = false

    if (!enabled) {
      setVehicle(null)
      setIsLoading(false)
      return () => { cancelled = true }
    }

    setIsLoading(true)

    const loadCurrentOrSuggested = async () => {
      if (currentVehicle) {
        if (!cancelled) setVehicle(currentVehicle)
        return
      }

      try {
        const card = await loadSuggestedVehicle()
        if (!cancelled) setVehicle(card)
      } catch {
        if (!cancelled) setVehicle(null)
      }
    }

    const load = async () => {
      if (preferOwnedGarage) {
        try {
          const owned = await vehiclesApi.getMyGarageCard()
          if (!cancelled) setVehicle(owned)
          return
        } catch {
          if (!cancelled) setVehicle(null)
          return
        }
      }

      await loadCurrentOrSuggested()
    }

    void load().finally(() => {
      if (!cancelled) setIsLoading(false)
    })
    return () => { cancelled = true }
  }, [enabled, preferOwnedGarage, currentVehicle, loadSuggestedVehicle])

  return { vehicle, isLoading }
}
